export interface IOutageModel {
    messageId: string;
    caseId: string;
    subject: string,
    title: string;
    subjectLocale: {frCA: string, enCA: string };
    titleLocale: {frCA: string, enCA: string };
    bodyLocale: {frCA: string, enCA: string };
    linkToLearnMoreLocale: {frCA: string, enCA: string};
    linkToLearnMore: string;
    body: string;
    outageType: string;
    targetApplications: string[];
    targetWorkflows: string[];
    startTime: string,
    endTime: string,
    createdDate: any,
    createdTime: string,
    startDate: any,
    endDate: string,
    targetEnterprises: string,
    targetStores: string,
    status: string,
    targetCNumbers: string,
    uploadedEnterprises: string,
    gridEnterpriseData: GridDataData[];
    gridCNumberData: GridDataData[];
    gridStoresData: GridDataData[];
    uploadedCNumbers: string,
    uploadedStores: string,
    showFileData: Boolean,
    gridEnterpriseSerachValue: string,
    gridCNumberSerachValue: string,
    gridStoresSearchValue: string
}

export interface IReleaseModel {
    includeTargets: any;
    messageId: string;
    subject: string,
    title: string;
    subjectLocale: {frCA: string, enCA: string };
    titleLocale: {frCA: string, enCA: string };
    linkToLearnMore: string;
    body: string;
    bodyLocale: {frCA: string, enCA: string };
    linkToLearnMoreLocale: {frCA: string, enCA: string};
    outageType: string;
    targetApplications: string[];
    targetWorkflows: string[];
    startTime: string,
    endTime: string,
    createdDate: any,
    createdTime: string,
    startDate: any,
    endDate: any,
    targetEnterprises: string,
    targetCNumbers: string,
    targetStores: string,
    status: string,
    uploadedEnterprises: string,
    gridEnterpriseData: GridDataData[];
    gridCNumberData: GridDataData[];
    gridStoresData: GridDataData[];
    uploadedCNumbers: string,
    uploadedStores: string,
    showFileData: Boolean,
    gridEnterpriseSerachValue: string,
    gridCNumberSerachValue: string,
    gridStoresSearchValue: string,
    departmentOptions: any[],
}

export const defaultOutageModel = {
    caseId: '',
    title: '',
    subject: '',
    linkToLearnMore: '',
    body: '',
    titleLocale: {enCA: "", frCA: ""},
    bodyLocale: {enCA: "", frCA: ""},
    subjectLocale: {enCA: "", frCA: ""},
    linkToLearnMoreLocale: {enCA: "", frCA: ""},
    targetApplications: [],
    targetWorkflows: [],
    targetEnterprises: '',
    outageType: 'Unplanned',
    startTime: '',
    endTime: '',
    createdDate: null,
    startDate: null,
    endDate: null,
    status: 'open'
};


export const defaultReleaseModel = {
    caseId: '',
    title: '',
    subject: '',
    titleLocale: {enCA: "", frCA: ""},
    bodyLocale: {enCA: "", frCA: ""},
    subjectLocale: {enCA: "", frCA: ""},
    linkToLearnMoreLocale: {enCA: "", frCA: ""},
    linkToLearnMore: '',
    body: '',
    targetApplications: [],
    targetWorkflows: [],
    targetEnterprises: '',
    startTime: '',
    endTime: '',
    createdDate: null,
    startDate: null,
    endDate: null,
    includeTargets: true
};

interface GridDataData {
    isSelected: boolean;
    name: string;
};